<template lang="pug">
van-popup(v-model="show")
  van-tabs(v-model="peopleType" @click="navClick")
    van-tab(title="选择人员" name="1")
    van-tab(title="选择系统角色" name="2")
    van-tab(title="选择项目角色" name="3")
  .peopleNav
    van-list(v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="peopleType=='1'")
      van-checkbox-group(v-model="result")
        van-checkbox(v-for="item,index in userList" :name="index" :key="index")
          .checkboxList
            span {{item.fullName}}
            span {{ item.mobilePhone }}
            span {{ item.orgName }}
    van-checkbox-group(v-model="filter.roleIds" v-else-if="peopleType=='2'")
      van-checkbox(v-for="item,index in sysData" :name="item.roleID" :key="index" )
        .checkboxList
          span {{item.roleName}}
    van-checkbox-group(v-model="filter.roleIds" v-else-if="peopleType=='3'")
      van-checkbox(v-for="item,index in roleData" :name="item.roleId" :key="index" )
        .checkboxList
          span {{item.roleName}}
  .sureFutton
    van-button(type="default" @click="cancel") 取消
    van-button(type="info"  @click="sure") 确定
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { Notify } from "vant";

export default {
  data () {
    return {
      show: false,
      loading: false,
      finished: false,
      refreshing: false,
      peopleType: "1",
      filter: {
        text: "",
        roleIds: []
      },
      filterTextRole: "",
      filterTextSys: "",
      result: [],
      orgTree: [],
      userList: [],
      sysData: [],
      roleData: [],
      curDept: {},
      page: {
        pageIndex: 0,
        pageSize: 5,
        totalCount: ''
      }
    };
  },
  computed: {
    ...mapState({
      localPrjId: state => state.projectMg.prjObj?.prjId,
      localEnterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo
    }),
    enterpriseId() {
      return this.$route.query.enterpriseId || this.localEnterpriseId;
    }
  },
  methods: {
    navClick(val) {
      switch (val) {
        case "1":

          break;
        case "2":
          this.getSysList();
          break;
        case "3":
          this.getRoleList();
          break;
      }
    },
    // 系统 角色
    async getSysList() {
      if (this.sysData?.length) return;
      const res = await flowService.querySysRoleList(this.enterpriseId);
      this.sysData = res.data;
    },
    // 项目 角色
    async getRoleList() {
      if (this.roleData?.length) return;
      const res = await flowService.querySpecRoleTree(this.enterpriseId);
      this.roleData = res.data?.map(item => {
        item.isSpec = true;
        return item;
      }) || [];
    },
    resetFilter() {
      this.filter = {
        text: "",
        roleIds: []
      };
      this.filterTextRole = "";
      this.filterTextSys = "";
    },
    openChoose() {
      this.page.pageIndex = 0;
      this.userList = [];
      this.show = true;
      // this.onLoad();
    },
    onLoad() {
      this.page.pageIndex++;
      this.getOrgPerson();
    },
    async getOrgPerson() {
      if (this.orgTree.length == 0) {
        const res = await flowService.getPersonChooseOrgTree(this.enterpriseId);
        this.orgTree = res.data;
      }
      const params = {
        orgId: this.orgTree[0].deptId, // 必填
        keyword: this.filter.text,
        sysRoleId: this.filter.roleIds,
        pageNo: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      const { data, totalCount, pageIndex } = await flowService.getPersonChooseOrgUser(params);
      this.page.pageIndex = pageIndex;
      this.page.totalCount = totalCount;
      this.loading = false;
      if (pageIndex === (parseInt(totalCount / this.page.pageSize) + 1)) {
        this.finished = true;
      }
      this.userList = [...this.userList, ...data];
    },
    cancel() {
      this.show = false;
    },
    sure() {
      if (this.peopleType !== "1") {
        this.show = false;
        return;
      }
      if (this.result.length !== 1) {
        Notify({ type: 'warning', message: '请选择一位成员' });
      } else if (this.result[0].userId === this.userInfo.userId) {
        Notify({ type: 'warning', message: '不能选择自己' });
      }
      console.log(this.result[0].userId);
      const data = this.userList.find((e, index) => this.result[0] == index);
      this.$emit("personChoose", data, this.peopleType);
      this.$emit("userSelected", data);
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup{
  height: 550px;
  overflow: hidden;
  .peopleNav{
    border-top: 1px solid #ccc;
    padding: 10px;
    height: 460px;
    overflow-y: auto;
    span{
      min-width: 60px;
    }
  }
  .sureFutton{
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    .van-button {
      height: 30px;
      padding: 5px 12px;
    }
  }
}
/deep/.van-tab{
  min-width: 120px;
}
/deep/.van-tabs__line{
  background-color: #4777E7;
}
/deep/.van-checkbox__label{
  width: calc(100% - 50px);
}
.checkboxList{
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

</style>
